const isDraft = exports.isDraft = id => id.startsWith('_local/')
exports.toDraft = id => isDraft(id) ? id : '_local/' + id
exports.fromDraft = id => id.replace(/^_local\//, '')
